import request from '@/utils/request'

export function listMeet() {
    return request({
        url: `/tdcs/meet-mavins`,
        method: 'get',
        params: { top: 6 }
    })
}